﻿<template>
  <div :class="['admin-room-container', 'figma-property-page', { 'is-embedded': embedded }]">
    <!-- Figma风格白色卡片容器 -->
    <div class="figma-white-card">
      <!-- 页面头部：标题 + 按钮 + 搜索 -->
      <div class="figma-page-header">
        <div v-if="!embedded" class="figma-page-title">房产管理</div>
        <div v-if="!embedded" class="figma-header-divider"></div>
        <!-- 第二行：按钮 + 搜索 -->
        <div class="figma-header-row">
          <!-- 操作按钮组 -->
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="handleAdd">
              <i class="el-icon-plus"></i>添加
            </el-button>
            <el-button size="small" class="figma-btn-import" @click="handleImport">
              <i class="el-icon-upload2"></i>导入
            </el-button>
            <el-button size="small" class="figma-btn-template" @click="handleDownloadTemplate">
              <i class="el-icon-download"></i>模版下载
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <!-- 搜索区域 -->
          <div class="figma-search-group">
            <el-input size="small" v-model="searchKeyword" placeholder="请输入小区信息" class="figma-search-input" clearable />
            <el-input size="small" v-model="searchForm.roomNum" placeholder="请输入房间号" class="figma-search-input"  clearable @keyup.enter.native="handleSearch" />
            <el-input size="small" v-model="searchForm.ownerName" placeholder="请输入业主姓名" class="figma-search-input"  clearable @keyup.enter.native="handleSearch" />
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="figma-table-section">
            <el-table :data="tableData" style="width: 100%" :fit="true" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
              <el-table-column prop="roomNum" label="房间号" min-width="90" show-overflow-tooltip sortable :sort-method="sortRoomNum" />
              <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip />
              <el-table-column prop="floorNum" label="楼号" min-width="64" show-overflow-tooltip />
              <el-table-column prop="unitNum" label="单元号" min-width="76" show-overflow-tooltip />
              <el-table-column prop="layer" label="楼层" min-width="64" show-overflow-tooltip />
              <el-table-column prop="roomSubTypeName" label="房屋类型" min-width="90" show-overflow-tooltip />
              <el-table-column prop="builtUpArea" label="建筑面积(平方)" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.builtUpArea || '-' }}</template>
              </el-table-column>
              <!-- <el-table-column prop="roomArea" label="室内面积(平方)" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.roomArea || '-' }}</template>
              </el-table-column> -->
              <el-table-column prop="personRoleName" label="角色" min-width="90" show-overflow-tooltip />
              <el-table-column prop="ownerName" label="业主姓名" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <router-link v-if="scope.row.ownerName" class="owner-link" :to="`/views/aCommunity/adminOwnerDetail?ownerId=${scope.row.ownerId}`">
                    {{ scope.row.ownerName }}
                  </router-link>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="创建时间" min-width="150" show-overflow-tooltip />
              <el-table-column prop="stateName" label="房屋状态" min-width="100">
                <template slot-scope="scope">
                  <span :class="['status-tag', getStateClass(scope.row.state)]">{{ scope.row.stateName || '未知' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="96">
                <template slot-scope="scope">
                  <span class="action-links">
                    <a class="action-link" @click="handleDetail(scope.row)">编辑</a>
                    <span class="link-separator"></span>
                    <a class="action-link" @click="handleDelete(scope.row)">删除</a>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页 -->
          <div class="figma-pagination">
            <span class="pagination-total">共{{ pagination.total }}条</span>
            <el-pagination
              :current-page="pagination.current"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pagination.size"
              layout="prev, pager, next, jumper"
              :total="pagination.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <el-select v-model="pagination.size" size="small" class="pagination-size-select">
              <el-option label="10条/页" :value="10" />
              <el-option label="20条/页" :value="20" />
              <el-option label="50条/页" :value="50" />
            </el-select>
          </div>

      <!-- 导入弹窗 -->
      <el-dialog
        :visible.sync="importDialogVisible"
        title="导入房产"
        width="500px"
        class="figma-add-dialog"
        :close-on-click-modal="false"
      >
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleFileChange"
          :limit="1"
          accept=".xlsx,.xls"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传 xlsx/xls 文件</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button class="figma-dialog-btn-cancel" @click="importDialogVisible = false">取消</el-button>
          <el-button class="figma-dialog-btn-confirm" type="primary" :loading="importLoading" @click="handleImportConfirm">确定</el-button>
        </span>
      </el-dialog>

      <!-- 右侧滑出面板 -->
      <div class="slide-mask" :class="{ 'is-visible': addDialogVisible }" @click="addDialogVisible = false"></div>
      <div class="slide-panel" :class="{ 'is-open': addDialogVisible }">
        <div class="slide-panel-header">
          <span class="slide-panel-title">{{ dialogTitle }}</span>
        </div>
        <div class="slide-panel-body">
          <el-form :model="addForm" :rules="addRules" ref="addFormRef" label-position="top">
            <el-form-item label="小区" prop="communityId">
              <el-select v-model="addForm.communityId" placeholder="请选择" class="figma-form-select" @change="handleCommunityChange">
                <el-option label="请选择" value="" />
                <el-option v-for="item in communityList" :key="item.communityId" :label="item.name" :value="item.communityId" />
              </el-select>
            </el-form-item>
            <el-form-item label="楼栋" prop="floorNum">
              <el-input v-model="addForm.floorNum" placeholder="请输入" class="figma-form-input" oninput="value=value.replace(/[^0-9]/g,'')" />
            </el-form-item>
            <el-form-item label="单元" prop="unitNum">
              <el-input v-model="addForm.unitNum" placeholder="请输入" class="figma-form-input" oninput="value=value.replace(/[^0-9]/g,'')" />
            </el-form-item>
            <el-form-item label="楼层" prop="layer">
              <el-input v-model="addForm.layer" placeholder="请输入" class="figma-form-input" oninput="value=value.replace(/[^0-9]/g,'')" />
            </el-form-item>
            <el-form-item label="房屋" prop="roomNum">
              <el-input v-model="addForm.roomNum" placeholder="请输入" class="figma-form-input" oninput="value=value.replace(/[^0-9]/g,'')" />
            </el-form-item>
            <el-form-item label="房屋类型" prop="roomSubType">
              <el-select v-model="addForm.roomSubType" placeholder="请选择" class="figma-form-select">
                <el-option label="请选择" value="" />
                <el-option v-for="item in roomSubTypes" :key="item.roomSubType" :label="item.roomSubTypeName" :value="item.roomSubType" />
              </el-select>
            </el-form-item>
            <el-form-item label="建筑面积(㎡)" prop="builtUpArea">
              <el-input v-model="addForm.builtUpArea" placeholder="请输入" class="figma-form-input" />
            </el-form-item>
            <!-- <el-form-item label="室内面积(㎡)" prop="roomArea">
              <el-input v-model="addForm.roomArea" placeholder="请输入" class="figma-form-input" />
            </el-form-item> -->
            <el-form-item label="房屋状态" prop="state">
              <el-select v-model="addForm.state" placeholder="请选择" class="figma-form-select" @change="handleStateChange">
                <el-option label="请选择" value="" />
                <el-option v-for="item in states" :key="item.state" :label="item.stateName" :value="item.state" />
              </el-select>
            </el-form-item>
            <el-form-item label="业主信息" prop="ownerId" v-if="addForm.state !== '2002'">
              <div class="owner-select-row">
                <el-select v-model="addForm.ownerId" placeholder="请选择" class="figma-form-select owner-select" clearable>
                  <el-option label="请选择" value="" />
                  <el-option v-for="item in ownerList" :key="item.memberId" :label="item.name" :value="item.memberId" />
                </el-select>
                <el-button class="figma-btn-add-owner" type="primary" @click="handleAddOwner">
                  <i class="el-icon-plus"></i>添加业主信息
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="slide-panel-footer">
          <el-button class="figma-dialog-btn-confirm" type="primary" @click="handleAddConfirm">确定</el-button>
          <el-button class="figma-dialog-btn-cancel" @click="addDialogVisible = false">取消</el-button>
        </div>
      </div>
    </div>

    <!-- 添加业主信息弹窗 -->
    <el-dialog
      :visible.sync="ownerDialogVisible"
      title="添加"
      width="650px"
      custom-class="figma-owner-dialog"
      append-to-body
      :close-on-click-modal="false"
      @close="handleOwnerDialogClose"
    >
      <el-form :model="ownerForm" :rules="ownerRules" ref="ownerFormRef" label-width="110px" label-position="left" class="owner-align-form">
        <el-form-item label="小区" prop="communityId">
          <el-select v-model="ownerForm.communityId" placeholder="请选择" class="figma-form-select">
            <el-option v-for="item in communityList" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item label="人员类型" prop="personType">
          <el-select v-model="ownerForm.personType" placeholder="请选择" class="figma-form-select">
            <el-option v-for="item in personTypes" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="人员角色" prop="personRole">
          <el-select v-model="ownerForm.personRole" placeholder="请选择" class="figma-form-select">
            <el-option v-for="item in personRoles" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户姓名" prop="name">
          <el-input v-model="ownerForm.name" placeholder="请输入" class="figma-form-input" />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="ownerForm.tel" placeholder="请输入" class="figma-form-input" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="ownerForm.sex" placeholder="请选择" class="figma-form-select">
            <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="idCard">
          <el-input v-model="ownerForm.idCard" placeholder="请输入" class="figma-form-input" />
        </el-form-item>
        <el-form-item label="上传照片" prop="ownerPhoto" class="owner-photo-form-item">
          <el-upload
            class="owner-photo-uploader"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleOwnerPhotoChange"
            accept="image/*"
          >
            <img v-if="ownerForm.ownerPhoto" :src="ownerForm.ownerPhoto" class="owner-photo-preview" />
            <div v-else class="owner-photo-placeholder">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="ownerForm.remark" placeholder="请输入" class="figma-form-input" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="figma-dialog-btn-cancel" @click="ownerDialogVisible = false">取消</el-button>
        <el-button class="figma-dialog-btn-confirm" type="primary" @click="handleSaveOwner">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listCommunitys } from '@/api/community/communityManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import { saveRoom, queryFloors, queryUnits, queryOwners, saveOwner } from '@/api/room/addRoomViewApi'
import { addFloor } from '@/api/room/addFloorApi'
import { saveUnit } from '@/api/room/addUnitApi'
import { queryRooms, downloadRoomTemplate, importRooms } from '@/api/room/roomApi'
import { updateRoom } from '@/api/room/editRoomApi'
import { deleteRoom } from '@/api/room/deleteRoomApi'

export default {
  name: 'AdminRoomList',
  props: {
    communityId: {
      type: [String, Number],
      default: ''
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKeyword: '',
      searchForm: {
        communityId: '',
        floorId: '',
        unitId: '',
        ownerNameLike: '',
        ownerTel: '',
        roomNum: '',
        state: '',
        roomSubType: '',
        startTime: '',
        page: 1,
        row: 10
      },
      tableData: [],
      states: [
        { state: '2001', stateName: '已入住' },
        { state: '2002', stateName: '未销售' },
        { state: '2003', stateName: '已交房' },
        { state: '2004', stateName: '未入住' },
        { state: '2005', stateName: '已装修' },
        { state: '2009', stateName: '装修中' }
      ],
      roomSubTypes: [
        { roomSubType: '110', roomSubTypeName: '住宅' },
        { roomSubType: '120', roomSubTypeName: '办公室' },
        { roomSubType: '119', roomSubTypeName: '宿舍' }
      ],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      loading: false,
      // 添加/编辑弹窗
      addDialogVisible: false,
      dialogTitle: '添加',
      isEdit: false,
      // 添加业主弹窗
      ownerDialogVisible: false,
      ownerForm: {
        communityId: '',
        personType: '',
        personRole: '',
        name: '',
        tel: '',
        sex: '',
        idCard: '',
        ownerPhoto: '',
        remark: ''
      },
      personTypes: [
        { value: 'P', label: '个人' },
        { value: 'C', label: '公司' }
      ],
      personRoles: [
        { value: '1', label: '业主' },
        { value: '2', label: '租客' },
        { value: '3', label: '家庭成员' },
        { value: '4', label: '公司员工' },
        { value: '99', label: '其他' }
      ],
      sexOptions: [
        { value: '1', label: '男' },
        { value: '0', label: '女' }
      ],
      ownerRules: {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        personType: [{ required: true, message: '请选择人员类型', trigger: 'change' }],
        personRole: [{ required: true, message: '请选择人员角色', trigger: 'change' }],
        name: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        idCard: [{ required: true, message: '请输入证件号', trigger: 'blur' }]
      },
      addForm: {
        roomId: '',
        communityId: '',
        floorNum: '',
        unitId: '',
        unitNum: '',
        roomNum: '',
        layer: '',
        roomSubType: '110',
        builtUpArea: '',
        roomArea: '',
        state: '2002',
        ownerId: ''
      },
      addRules: {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        floorNum: [
          { required: true, message: '请输入楼栋', trigger: 'blur' },
          { pattern: /^\d+$/, message: '楼栋只能是数字', trigger: 'blur' }
        ],
        unitNum: [
          { required: true, message: '请输入单元', trigger: 'blur' },
          { pattern: /^\d+$/, message: '单元只能是数字', trigger: 'blur' }
        ],
        roomNum: [
          { required: true, message: '请输入房屋', trigger: 'blur' },
          { pattern: /^\d+$/, message: '房屋号只能是数字', trigger: 'blur' }
        ],
        layer: [
          { required: true, message: '请输入楼层', trigger: 'blur' },
          { pattern: /^\d+$/, message: '楼层只能是数字', trigger: 'blur' }
        ],
        roomSubType: [{ required: true, message: '请选择房屋类型', trigger: 'change' }],
        builtUpArea: [{ required: true, message: '请输入建筑面积', trigger: 'blur' }],
        state: [{ required: true, message: '请选择房屋状态', trigger: 'change' }],
        ownerId: [{
          validator: (rule, value, callback) => {
            if (this.addForm.state !== '2002' && !value) {
              callback(new Error('请选择业主'))
              return
            }
            callback()
          },
          trigger: 'change'
        }]
      },
      communityList: [],
      floorList: Array.from({ length: 50 }, (_, i) => ({ floorId: String(i + 1), floorName: String(i + 1) + '栋' })),
      ownerList: [],
      // 导入弹窗
      importDialogVisible: false,
      importFile: null,
      importLoading: false
    }
  },
  watch: {
    communityId() {
      this.initData()
      this.getList()
    }
  },
  async created() {
    await this._loadCommunityList()
    this.initData()
    this.getList()
  },
  methods: {
    _formatCommunityId(communityId) {
      const value = communityId === undefined || communityId === null ? '' : String(communityId)
      return value && value !== '-1' ? value : ''
    },
    _getPageCommunityId(...communityIds) {
      const fromParams = communityIds.map(item => this._formatCommunityId(item)).find(Boolean)
      if (fromParams) {
        return fromParams
      }
      const firstCommunity = this.communityList.find(item => this._formatCommunityId(item.communityId))
      return firstCommunity ? String(firstCommunity.communityId) : ''
    },
    _normalizeRoomRows(rows) {
      return (rows || []).map(row => ({
        ...row,
        roomSubTypeName: this._getRoomSubTypeName(row)
      }))
    },
    _getRoomSubTypeName(row) {
      if (row.roomSubTypeName) {
        return row.roomSubTypeName
      }
      const roomSubType = row.roomSubType || row.room_sub_type
      const match = this.roomSubTypes.find(item => String(item.roomSubType) === String(roomSubType))
      return match ? match.roomSubTypeName : '-'
    },
    _getCommunityIdByName(communityName) {
      const currentName = communityName === undefined || communityName === null ? '' : String(communityName).trim()
      if (!currentName) {
        return ''
      }
      const currentCommunity = this.communityList.find(item => String(item.name || item.communityName || '').trim() === currentName)
      return currentCommunity ? this._formatCommunityId(currentCommunity.communityId) : ''
    },
    _getRowCommunityId(row) {
      return this._formatCommunityId(row.communityId || row.community_id || row.communityCode) || this._getCommunityIdByName(row.communityName)
    },
    initData() {
      this.searchForm.communityId = this._formatCommunityId(this.communityId) || this._formatCommunityId(this.$route.query.communityId) || '-1'
    },
    async getList() {
      try {
        this.loading = true
        const communityId = this._formatCommunityId(this.searchForm.communityId) || this._formatCommunityId(this.communityId) || this._formatCommunityId(this.$route.query.communityId) || '-1'
        this.searchForm.communityId = communityId
        const params = {
          ...this.searchForm,
          communityId
        }
        const res = await queryRooms(params)
        this.tableData = this._normalizeRoomRows(res.rooms || res.data || [])
        this.pagination.total = Number(res.total || res.records || 0)
        this.pagination.current = this.searchForm.page
        this.pagination.size = this.searchForm.row
      } catch (error) {
        console.error('获取列表失败:', error)
        this.$message.error(error.message || '获取列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.searchForm.page = 1
      this.getList()
    },
    handleSelectCommunity(data) {
      this.searchForm.communityId = this._formatCommunityId(data.communityId)
      this.searchForm.floorId = ''
      this.searchForm.unitId = ''
      this.getList()
    },
    handleSelectFloor(data) {
      this.searchForm.floorId = data.floorId || ''
      this.searchForm.unitId = ''
      this.getList()
    },
    handleSelectUnit(data) {
      this.searchForm.unitId = data.unitId || ''
      this.getList()
    },
    async handleDetail(row) {
      this.isEdit = true
      this.dialogTitle = '编辑'
      this.addDialogVisible = true
      await this._loadCommunityList()
      const rowCommunityId = this._getRowCommunityId(row)
      const currentCommunityId = rowCommunityId || this._getPageCommunityId(this.searchForm.communityId, this.communityId, this.$route.query.communityId, getCommunityId())
      if (currentCommunityId) {
        await this._loadOwners(currentCommunityId)
      }
      this.$nextTick(() => {
        this.addForm = {
          roomId: row.roomId || '',
          communityId: currentCommunityId,
          floorNum: row.floorNum ? String(row.floorNum) : '',
          unitId: row.unitId ? String(row.unitId) : '',
          unitNum: row.unitNum || '',
          roomNum: row.roomNum || '',
          layer: row.layer || '',
          roomSubType: row.roomSubType ? String(row.roomSubType) : '110',
          builtUpArea: row.builtUpArea || '',
          roomArea: row.roomArea || '',
          state: row.state ? String(row.state) : '2002',
          ownerId: row.ownerId ? String(row.ownerId) : ''
        }
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate()
      })
    },
    handleDialogClose() {
      this.isEdit = false
      this.dialogTitle = '添加'
      this.addForm = {
        roomId: '',
        communityId: '',
        floorNum: '',
        unitId: '',
        unitNum: '',
        roomNum: '',
        layer: '',
        roomSubType: '110',
        builtUpArea: '',
        roomArea: '',
        state: '2002',
        ownerId: ''
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除该房产？删除前请确认已解绑业主。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const params = {
            communityId: this._getPageCommunityId(row.communityId, this.searchForm.communityId, this.communityId, this.$route.query.communityId, getCommunityId()),
            roomId: row.roomId,
            unitId: row.unitId,
            floorId: row.floorId
          }
          if (!params.communityId) {
            this.$message.error('缺少小区ID，无法删除')
            return
          }
          if (!params.roomId) {
            this.$message.error('缺少房屋ID，无法删除')
            return
          }
          await deleteRoom(params)
          this.$message.success('删除成功')
          this.getList()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    },
    handleSizeChange(size) {
      this.searchForm.row = size
      this.searchForm.page = 1
      this.getList()
    },
    handleCurrentChange(current) {
      this.searchForm.page = current
      this.getList()
    },
    headerCellStyle() {
      return {
        background: '#EBF2FA',
        color: '#364153',
        fontSize: '14px',
        fontWeight: '500',
        fontFamily: 'PingFang SC',
        height: '50px'
      }
    },
    cellStyle({ row, columnIndex }) {
      // 斑马纹样式
      const rowIndex = this.tableData.indexOf(row)
      if (rowIndex % 2 === 1) {
        return {
          background: '#F8FBFF',
          color: '#1D2129',
          fontSize: '14px',
          fontFamily: 'PingFang SC',
          height: '50px'
        }
      }
      return {
        background: 'white',
        color: '#1D2129',
        fontSize: '14px',
        fontFamily: 'PingFang SC',
        height: '50px'
      }
    },
    getStateClass(state) {
      // 已入住: #21B956, 未销售: #8C9BB4
      if (state === '2002') {
        return 'status-occupied'
      }
      return 'status-unsold'
    },
    async handleAdd() {
      this.isEdit = false
      this.dialogTitle = '添加'
      this.addDialogVisible = true
      await this._loadCommunityList()
      const currentCommunityId = this._getPageCommunityId(this.searchForm.communityId, this.communityId, this.$route.query.communityId, getCommunityId())
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
        this.addForm.communityId = currentCommunityId
        this.addForm.roomSubType = '110'
        this.addForm.state = '2002'
        if (currentCommunityId) {
          this._loadOwners(currentCommunityId)
        }
      })
    },
    async _loadCommunityList() {
      try {
        const res = await listCommunitys({ page: 1, row: 1000 })
        this.communityList = (res.communitys || res.data || []).map(item => ({
          ...item,
          communityId: String(item.communityId)
        })).filter(item => this._formatCommunityId(item.communityId))
      } catch (error) {
        console.error('加载小区列表失败:', error)
      }
    },
    async _loadOwners(communityId) {
      const currentCommunityId = this._formatCommunityId(communityId)
      if (!currentCommunityId) {
        this.ownerList = []
        return
      }
      try {
        const res = await queryOwners({ page: 1, row: 1000, communityId: currentCommunityId })
        this.ownerList = (res.data || []).map(item => ({
          ...item,
          memberId: String(item.memberId)
        }))
      } catch (error) {
        console.error('加载业主列表失败:', error)
      }
    },
    handleCommunityChange(communityId) {
      const currentCommunityId = this._formatCommunityId(communityId)
      this.addForm.communityId = currentCommunityId
      if (!this.isEdit) {
        this.addForm.ownerId = ''
      }
      this._loadOwners(currentCommunityId)
    },
    handleStateChange(state) {
      if (state === '2002') {
        this.addForm.ownerId = ''
      }
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.validateField('ownerId')
      })
    },
    _buildRoomParams() {
      const params = {
        communityId: this._getPageCommunityId(this.addForm.communityId, this.searchForm.communityId, this.communityId, this.$route.query.communityId, getCommunityId()),
        roomId: this.addForm.roomId,
        roomNum: this.addForm.roomNum,
        layer: this.addForm.layer,
        floorNum: this.addForm.floorNum,
        unitNum: this.addForm.unitNum,
        section: '1',
        apartment: '10102',
        builtUpArea: this.addForm.builtUpArea,
        floorArea: this.addForm.builtUpArea,
        feeCoefficient: '1',
        state: this.addForm.state,
        roomSubType: this.addForm.roomSubType || '110',
        roomArea: this.addForm.roomArea,
        roomRent: '0',
        attrs: []
      }
      if (this.addForm.ownerId) {
        params.ownerId = this.addForm.ownerId
      }
      if (!this.isEdit) {
        delete params.roomId
      }
      if (this.addForm.unitId) {
        params.unitId = this.addForm.unitId
      }
      return params
    },
    async _ensureFloorExists(params) {
      const res = await queryFloors({
        page: 1,
        row: 1,
        communityId: params.communityId,
        floorNum: params.floorNum
      })
      const floors = res.apiFloorDataVoList || res.data || []
      if (floors.length > 0) {
        return floors[0].floorId
      }
      const saveRes = await addFloor({
        communityId: params.communityId,
        floorNum: params.floorNum,
        name: `${params.floorNum}栋`,
        floorArea: params.floorArea,
        seq: params.floorNum,
        remark: '新增房产时创建'
      })
      this._checkResponse(saveRes, '创建楼栋失败')
      const reloadRes = await queryFloors({
        page: 1,
        row: 1,
        communityId: params.communityId,
        floorNum: params.floorNum
      })
      const reloadedFloors = reloadRes.apiFloorDataVoList || reloadRes.data || []
      return reloadedFloors.length > 0 ? reloadedFloors[0].floorId : ''
    },
    async _ensureUnitExists(params, floorId) {
      if (!floorId) {
        throw new Error('创建楼栋失败')
      }
      const res = await queryUnits({
        page: 1,
        row: 1,
        communityId: params.communityId,
        floorId,
        unitNum: params.unitNum
      })
      const units = Array.isArray(res) ? res : (res.apiUnitDataVoList || res.data || [])
      if (units.length > 0) {
        return
      }
      await saveUnit({
        communityId: params.communityId,
        floorId,
        unitNum: params.unitNum,
        layerCount: params.layer,
        unitArea: params.builtUpArea,
        lift: '1010',
        remark: '新增房产时创建'
      })
    },
    _checkResponse(res, defaultMessage) {
      if (res && res.code !== undefined && String(res.code) !== '0') {
        throw new Error(res.msg || defaultMessage)
      }
    },
    handleDownloadTemplate() {
      downloadRoomTemplate().then(res => {
        const byteCharacters = atob(res.content)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = res.fileName || 'property_room_template.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
        this.$message.success('模板下载成功')
      }).catch(error => {
        this.$message.error(error.message || '模板下载失败')
      })
    },
    handleImport() {
      this.importDialogVisible = true
      this.importFile = null
    },
    handleFileChange(file, fileList) {
      const target = file && file.raw ? file.raw : (fileList && fileList.length > 0 ? fileList[0].raw : null)
      this.importFile = target
    },
    handleFileRemove() {
      this.importFile = null
    },
    handleImportConfirm() {
      if (!this.importFile) {
        this.$message.warning('请选择要导入的文件')
        return
      }
      this.importLoading = true
      const reader = new FileReader()
      reader.onload = (e) => {
        const base64 = e.target.result.split(',')[1]
        const communityId = this._getPageCommunityId(this.searchForm.communityId, this.communityId, this.$route.query.communityId, getCommunityId())
        const params = {
          communityId: communityId || '',
          excelData: base64
        }
        console.log('导入参数:', { communityId: params.communityId, excelDataLength: base64.length })
        importRooms(params).then(() => {
          this.$message.success('导入成功')
          this.importDialogVisible = false
          this.importFile = null
          this.getList()
        }).catch(error => {
          this.$message.error(error.message || '导入失败')
        }).finally(() => {
          this.importLoading = false
        })
      }
      reader.readAsDataURL(this.importFile)
    },
    handleAddOwner() {
      this.ownerDialogVisible = true
      this.$nextTick(() => {
        this.$refs.ownerFormRef && this.$refs.ownerFormRef.resetFields()
        this.ownerForm.communityId = this._getPageCommunityId(this.addForm.communityId, this.searchForm.communityId, this.communityId, this.$route.query.communityId, getCommunityId())
      })
    },
    handleOwnerDialogClose() {
      this.ownerForm = {
        communityId: '',
        personType: '',
        personRole: '',
        name: '',
        tel: '',
        sex: '',
        idCard: '',
        ownerPhoto: '',
        remark: ''
      }
    },
    handleOwnerPhotoChange(file) {
      const raw = file.raw
      if (!raw) return
      if (!raw.type.startsWith('image/')) {
        this.$message.warning('请上传图片文件')
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        this.ownerForm.ownerPhoto = e.target.result
      }
      reader.readAsDataURL(raw)
    },
    async handleSaveOwner() {
      this.$refs.ownerFormRef.validate(async (valid) => {
        if (valid) {
          try {
            const communityId = this._formatCommunityId(this.ownerForm.communityId)
            const params = {
              communityId,
              name: this.ownerForm.name,
              link: this.ownerForm.tel,
              sex: this.ownerForm.sex,
              personType: this.ownerForm.personType,
              personRole: this.ownerForm.personRole,
              idCard: this.ownerForm.idCard || '',
              address: '',
              ownerId: '-1',
              remark: this.ownerForm.remark || '',
              ownerPhoto: this.ownerForm.ownerPhoto || ''
            }
            const res = await saveOwner(params)
            const ownerId = res && (res.ownerId || res.memberId || res.data && (res.data.ownerId || res.data.memberId))
            this.$message.success('添加成功')
            this.ownerDialogVisible = false
            // 刷新业主列表并回填
            if (communityId) {
              this.addForm.communityId = communityId
              await this._loadOwners(communityId)
            }
            // 回填到房屋表单
            if (ownerId) {
              const newOwnerId = String(ownerId)
              // 确保新业主在列表中
              const exists = this.ownerList.some(item => String(item.memberId) === newOwnerId)
              if (!exists) {
                this.ownerList.push({
                  memberId: newOwnerId,
                  name: this.ownerForm.name
                })
              }
              this.addForm.ownerId = newOwnerId
            }
          } catch (error) {
            this.$message.error(error.message || '添加失败')
          }
        }
      })
    },
    handleAddConfirm() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {
          try {
            const params = this._buildRoomParams()
            if (!params.communityId) {
              throw new Error('请选择小区')
            }
            if (this.isEdit) {
              await updateRoom(params)
              this.$message.success('更新成功')
            } else {
              const floorId = await this._ensureFloorExists(params)
              await this._ensureUnitExists(params, floorId)
              const res = await saveRoom(params)
              this._checkResponse(res, '添加失败')
              this.$message.success('添加成功')
            }
            this.addDialogVisible = false
            this.getList()
          } catch (error) {
            this.$message.error(error.message || (this.isEdit ? '更新失败' : '添加失败'))
          }
        }
      })
    },
    sortRoomNum(a, b) {
      const numA = Number(a.roomNum)
      const numB = Number(b.roomNum)
      const valA = isNaN(numA) ? String(a.roomNum || '') : numA
      const valB = isNaN(numB) ? String(b.roomNum || '') : numB
      if (typeof valA === 'number' && typeof valB === 'number') {
        return valA - valB
      }
      return valA < valB ? -1 : (valA > valB ? 1 : 0)
    }
  }
}
</script>

<style scoped>
/* 整体容器 */
.admin-room-container {
  height: calc(100vh - 60px);
  background: #EBF2FA;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Figma白色卡片 */
.figma-white-card {
  background: white;
  border-radius: 0 0 12px 12px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 页面头部 */
.figma-page-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 24px;
  gap: 12px;
}

.figma-page-title {
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
  margin-bottom: 8px;
}

.admin-room-container.is-embedded {
  height: 100%;
  background: #FFFFFF;
}

.admin-room-container.is-embedded .figma-white-card {
  border-radius: 0;
}

.admin-room-container.is-embedded .figma-page-header {
  padding: 24px 24px 0;
}

.admin-room-container.is-embedded .figma-table-section {
  padding-top: 24px;
}

/* 标题与按钮行之间的分割线 */
.figma-header-divider {
  width: 100%;
  height: 1px;
  background: #DCE6F5;
  margin-bottom: 16px;
}

/* 第二行：按钮 + 搜索 */
.figma-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 12px;
}

/* 按钮组 */
.figma-btn-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.figma-btn-add,
.figma-btn-import,
.figma-btn-template {
  height: 38px;
  border-radius: 10px !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0 16px !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.figma-btn-add {
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
}

.figma-btn-add:hover {
  background: #0A6AE5 !important;
}

.figma-btn-import {
  background: #FF6900 !important;
  border: none !important;
  color: white !important;
}

.figma-btn-import:hover {
  background: #E55D00 !important;
}

.figma-btn-template {
  background: #6A7282 !important;
  border: none !important;
  color: white !important;
}

.figma-btn-template:hover {
  background: #5A6169 !important;
}

.figma-btn-refresh {
  height: 38px;
  width: 38px;
  border-radius: 10px !important;
  border: 1px solid #DCE6F5 !important;
  background: white !important;
  color: #6A7282 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.figma-btn-refresh:hover {
  border-color: #0E76FF !important;
  color: #0E76FF !important;
}

/* 搜索区域 */
.figma-search-group {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.figma-search-input {
  width: 140px;
  min-width: 100px;
  flex: 0 1 140px;
  height: 38px;
}

.figma-search-date {
  width: 160px;
  height: 38px;
}

.figma-search-input >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #0E76FF solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
}

.figma-btn-search {
  height: 38px;
  flex-shrink: 0;
  border-radius: 10px !important;
  border: none !important;
  outline: 1px #0E76FF solid !important;
  outline-offset: -1px;
  color: #0E76FF !important;
  background: white !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.figma-btn-search:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}

/* 小屏适配：搜索框收窄，确保搜索按钮可见 */
@media (max-width: 1200px) {
  .figma-search-input {
    width: 120px;
    flex: 0 1 120px;
  }
}

@media (max-width: 992px) {
  .figma-search-input {
    width: 100px;
    min-width: 90px;
    flex: 1 1 100px;
  }
}

/* 表格区域 */
.figma-table-section {
  flex: 1;
  padding: 0 24px;
  overflow: auto;
}

.figma-table-section >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.figma-table-section >>> .el-table__header-wrapper {
  border-radius: 8px;
}

.figma-table-section >>> .el-table__header th {
  background: #EBF2FA !important;
  border: none !important;
}

.figma-table-section >>> .el-table__body td {
  border: none !important;
  border-bottom: 1px solid #F0F0F0 !important;
}

.figma-table-section >>> .el-table__body tr:nth-child(even) td {
  background: #F8FBFF;
}

/* 业主链接 */
.owner-link {
  color: #1D2129;
  text-decoration: none;
  font-weight: 500;
}

.owner-link:hover {
  color: #0E76FF;
}

/* 状态标签 */
.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
}

.status-occupied {
  background: rgba(33, 185, 86, 0.10);
  color: #21B956;
  border: 1px solid #21B956;
}

.status-unsold {
  background: rgba(140, 155, 180, 0.10);
  color: #8C9BB4;
  border: 1px solid #8C9BB4;
}

/* 操作链接 */
.action-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-link {
  color: #0E76FF;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
}

.action-link:hover {
  text-decoration: underline;
}

.link-separator {
  color: #0E76FF;
}

/* 分页 */
.figma-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 16px;
  border-top: 1px solid #DCE6F5;
}

.pagination-total {
  font-size: 14px;
  color: #1D2129;
  font-family: 'PingFang SC';
}

.figma-pagination >>> .el-pagination {
  display: flex;
  align-items: center;
}

.figma-pagination >>> .el-pager li {
  border-radius: 8px;
  font-weight: 500;
  font-family: 'Nunito Sans';
}

.figma-pagination >>> .el-pager li.active {
  background: #E8F3FF;
  color: #0E76FF;
}

.figma-pagination >>> .el-pager li:hover {
  color: #0E76FF;
}

.pagination-size-select {
  width: 92px;
}

.pagination-size-select >>> .el-input__inner {
  border-radius: 8px;
  background: #F2F3F5;
  border: none;
  font-size: 14px;
}

/* 右侧滑出面板 */
.slide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.60);
  z-index: 1999;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.slide-mask.is-visible {
  opacity: 1;
  pointer-events: auto;
}

.slide-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 650px;
  max-width: 100vw;
  height: 100vh;
  background: #FFFFFF;
  z-index: 2000;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.08);
}

.slide-panel.is-open {
  transform: translateX(0);
}

.slide-panel-header {
  height: 66px;
  background: #EBF2FA;
  border-top-left-radius: 12px;
  border-bottom: 1px solid #DCE6F5;
  padding: 0 24px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
}

.slide-panel-title {
  font-size: 16px;
  line-height: 22px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  color: #1D2129;
}

.slide-panel-body {
  flex: 1;
  padding: 24px 24px 0;
  overflow-y: auto;
}

.slide-panel-body >>> .el-form-item {
  margin-bottom: 20px;
}

.slide-panel-body >>> .el-form-item:last-child {
  margin-bottom: 0;
}

.slide-panel-body >>> .el-form--label-top .el-form-item__label,
.slide-panel-body >>> .el-form-item__label {
  display: block;
  width: 100%;
  float: none;
  font-size: 14px;
  color: #1D2129;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  line-height: 20px;
  padding: 0 0 8px;
  text-align: left !important;
  box-sizing: border-box;
}

.slide-panel-body >>> .el-form-item__label::before {
  margin-right: 0;
  color: #FB2C36;
}

.slide-panel-body >>> .el-form-item__content {
  line-height: 38px;
}

.owner-select-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.owner-select {
  flex: 1;
  min-width: 0;
}

.figma-btn-add-owner {
  width: 138px;
  height: 38px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', 'PingFang SC', sans-serif;
  background: #0E76FF;
  border: none;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
}

.figma-btn-add-owner:hover {
  background: #0A6AE5;
}

.slide-panel-footer {
  height: 94px;
  background: #FFFFFF;
  border-top: 1px solid #DCE6F5;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.slide-panel-footer >>> .el-button + .el-button {
  margin-left: 0;
}

.figma-form-input,
.figma-form-select {
  width: 100%;
}

.figma-form-input >>> .el-input__inner,
.figma-form-select >>> .el-input__inner {
  height: 38px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #DCE6F5;
  font-size: 14px;
  font-family: 'Inter', 'PingFang SC', sans-serif;
  font-weight: 400;
  color: #1D2129;
}

.figma-form-input >>> .el-input__inner::placeholder,
.figma-form-select >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-form-input >>> .el-input__inner:focus,
.figma-form-select >>> .el-input__inner:focus {
  border-color: #0E76FF;
  outline: none;
}

.figma-dialog-btn-cancel,
.figma-dialog-btn-confirm {
  width: 98px;
  height: 38px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
  padding: 0;
}

.figma-dialog-btn-cancel {
  background: #FFFFFF;
  border: 1px solid #0E76FF;
  color: #0E76FF;
}

.figma-dialog-btn-cancel:hover {
  border-color: #0E76FF;
  color: #0E76FF;
  background: rgba(14, 118, 255, 0.08);
}

.figma-dialog-btn-confirm {
  background: #0E76FF;
  border: none;
  color: #FFFFFF;
}

.figma-dialog-btn-confirm:hover {
  background: #0A6AE5;
}

/* 添加业主弹窗样式 */
.figma-owner-dialog {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
}

.figma-owner-dialog >>> .el-dialog__header {
  height: 66px;
  padding: 0 24px;
  background: #EBF2FA;
  border-bottom: none;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.figma-owner-dialog >>> .el-dialog__title {
  color: #1D2129;
  font: 600 16px/22px 'PingFang SC', sans-serif;
}

.figma-owner-dialog >>> .el-dialog__headerbtn {
  display: none;
}

.figma-owner-dialog >>> .el-dialog__body {
  flex: 1;
  max-height: calc(100vh - 220px);
  padding: 24px 24px 0;
  overflow-y: auto;
}

.figma-owner-dialog >>> .el-form-item {
  margin-bottom: 20px !important;
}

.figma-owner-dialog >>> .el-form-item:last-child {
  margin-bottom: 0;
}

.figma-owner-dialog >>> .el-form-item__label {
  color: #1D2129;
  font: 500 14px/38px 'PingFang SC', sans-serif;
  padding: 0 16px 0 0;
  text-align: right;
  white-space: nowrap;
}

.figma-owner-dialog >>> .el-form-item__label::before {
  margin-right: 0;
  color: #FB2C36;
}

.figma-owner-dialog >>> .el-form-item__content {
  line-height: 38px;
}

.figma-owner-dialog >>> .figma-form-input,
.figma-owner-dialog >>> .figma-form-select {
  width: 100%;
}

.figma-owner-dialog >>> .figma-form-input .el-input__inner,
.figma-owner-dialog >>> .figma-form-select .el-input__inner {
  height: 38px !important;
  line-height: 38px !important;
  padding-left: 16px;
  border-radius: 10px;
  border: 1px solid #DCE6F5;
  color: #1D2129;
  font: 400 14px/38px Inter, 'PingFang SC', sans-serif;
}

.figma-owner-dialog >>> .figma-form-input .el-input__inner::placeholder,
.figma-owner-dialog >>> .figma-form-select .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-owner-dialog >>> .el-dialog__footer {
  padding: 0 24px 28px;
  border-top: none;
  background: #FFFFFF;
  text-align: right;
}

.figma-owner-dialog .dialog-footer {
  display: inline-flex;
  gap: 12px;
}

.figma-owner-dialog .figma-dialog-btn-cancel,
.figma-owner-dialog .figma-dialog-btn-confirm {
  width: 98px;
  height: 38px;
  padding: 0;
  border-radius: 10px;
  font: 500 14px/38px 'PingFang SC', sans-serif;
}

.figma-owner-dialog .figma-dialog-btn-cancel {
  border: 1px solid #0E76FF;
  color: #0E76FF;
}

/* 标签与输入框水平对齐 */
.owner-align-form >>> .el-form-item {
  display: block;
}

.owner-align-form >>> .el-form-item::after {
  content: '';
  display: table;
  clear: both;
}

.owner-align-form >>> .el-form-item__label {
  float: left;
  width: 110px !important;
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
}

.owner-align-form >>> .el-form-item__content {
  width: calc(100% - 110px);
  margin-left: 110px !important;
  line-height: normal;
}

.owner-align-form >>> .el-form-item__error {
  padding-top: 2px;
}

.owner-photo-form-item {
  margin-bottom: 20px !important;
}

/* 上传照片 */
.owner-photo-uploader >>> .el-upload {
  width: 82px;
  height: 82px;
  border: 1px dashed #0E76FF;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(14, 118, 255, 0.08);
  transition: background 0.2s;
}

.owner-photo-uploader >>> .el-upload:hover {
  background: rgba(14, 118, 255, 0.12);
}

.owner-photo-preview {
  width: 82px;
  height: 82px;
  object-fit: cover;
  border-radius: 8px;
}

.owner-photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0E76FF;
}

.owner-photo-placeholder i {
  font-size: 28px;
  font-weight: 400;
}
</style>
